import RazorPayImg from "../../assets/img/razorpay.jpg";
import { useUpdatePaymentStatus } from "./update_status";

const RazorPayForm = ({
  setActivePaymentMethod,
  activePaymentMethod,
  selectedPlan,
}) => {
  const updatePaymentStatus = useUpdatePaymentStatus();

  const handleShowRazorPay = () => {
    setActivePaymentMethod("razorpay");
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const handleRazorPay = async (e) => {
    setActivePaymentMethod("razorpay");
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const amount = formData.get("amount");

    const isLoaded = await loadRazorpayScript();

    if (!isLoaded) {
      alert("Failed to load Razorpay SDK. Please check your connection.");
      return;
    }

    const paymentAmountInPaisa = amount * 100;

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: paymentAmountInPaisa,
      currency: "INR",
      name: "MathSpeedUp",
      description: "Payment for product/service",
      image: "../assets/img/favicon.png",
      handler: (response) => {
        if (window.location.pathname.includes("/payment")) {
          updatePaymentStatus(selectedPlan);
        }
      },
      theme: {
        color: "#3399cc",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
    form.reset();
    setActivePaymentMethod(null);
  };

  return (
    <>
      {" "}
      <div className="payment-option" onClick={handleShowRazorPay}>
        <span>
          <input
            type="radio"
            name="razorpayMethod"
            value="razorpay"
            checked={activePaymentMethod === "razorpay"}
            onChange={handleShowRazorPay}
          />
          <img src={RazorPayImg} height={50} width={50} alt="RazorPayImg" />
          RazorPay{" "}
        </span>
        {activePaymentMethod === "razorpay" && (
          <form id="paymentForm" onSubmit={handleRazorPay}>
            <input
              type="number"
              className="form-control"
              name="amount"
              id="amount"
              placeholder="Amount*"
              required
              autoComplete="off"
              defaultValue={selectedPlan ? selectedPlan.amount : ""}
              disabled={selectedPlan ? true : false}
            />
            <button
              className="btn btn-success"
              style={{
                padding: "10px 85px",
                marginTop: "5px",
              }}
            >
              Pay
            </button>
          </form>
        )}
      </div>
    </>
  );
};

export default RazorPayForm;
